import { render, staticRenderFns } from "./AppDotNotification.vue?vue&type=template&id=e529fef2&scoped=true&"
import script from "./AppDotNotification.vue?vue&type=script&lang=js&"
export * from "./AppDotNotification.vue?vue&type=script&lang=js&"
import style0 from "./AppDotNotification.vue?vue&type=style&index=0&id=e529fef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e529fef2",
  null
  
)

export default component.exports